import { render, staticRenderFns } from "./CompanyRegistration.vue?vue&type=template&id=e8492ef0&scoped=true&class=register-page&"
import script from "./CompanyRegistration.vue?vue&type=script&lang=js&"
export * from "./CompanyRegistration.vue?vue&type=script&lang=js&"
import style0 from "./CompanyRegistration.vue?vue&type=style&index=0&id=e8492ef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8492ef0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VSelect,VTextField})
